module.exports = __webpack_public_path__ + "static/media/emoji.4f9ba155.svg";